import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDashboardData } from '../../state/DashboardDataContext.jsx';
import { useUpgrade } from '../../contexts/UpgradeContext.jsx';
import { effectiveAccessState } from '../../lib/billingState.js';
import { freePublishingState } from '../../lib/freePublishing.js';

// Only canonical, current entitlements can prove either access or a lapse.
// Quotas/features still decide which actions a non-lapsed plan includes.
export function creationAccessState(dash) {
  const state = dash.entitlementsError ? null : effectiveAccessState(dash.entitlements);
  return state === 'lapsed' ? 'lapsed' : state ? 'allowed' : 'unknown';
}

export default function CreationAccessNotice({ feature = 'default' }) {
  const { t } = useTranslation();
  const dash = useDashboardData();
  const { openUpgrade } = useUpgrade();
  const [retrying, setRetrying] = useState(false);
  const state = creationAccessState(dash);
  if (state === 'allowed') return null;

  if (state === 'lapsed' && feature === 'assistant' && freePublishingState(dash.entitlements)) {
    return (
      <section className="card flb-banner" role="status">
        <div className="flb-msg"><strong>{t('textLocked.assistantLockedLabel')}</strong></div>
        <div className="flb-actions">
          <Link className="btn btn-primary" to="/app/plans">{t('textLocked.viewPlans')}</Link>
        </div>
      </section>
    );
  }

  const retry = async () => {
    if (retrying) return;
    setRetrying(true);
    try { await dash.refreshEntitlements({ maxAttempts: 1 }); }
    finally { setRetrying(false); }
  };
  return (
    <section className="card flb-banner" role="status">
      <div className="flb-msg">
        <strong>{t(state === 'lapsed' ? 'lapsed.bannerTitle' : 'settings.loadingPlan')}</strong>
        <div>{t(state === 'lapsed' ? 'paymentIssue.lapsedBody' : dash.entitlementsError ? 'settings.billingStatusLoadError' : 'settings.checkingAccess')}</div>
      </div>
      <div className="flb-actions">
        {state === 'lapsed' ? (
          <button type="button" className="btn btn-primary" onClick={() => openUpgrade({ feature: 'default', variant: 'renew' })}>
            {t('lapsed.renew')}
          </button>
        ) : (
          <button type="button" className="btn btn-secondary" disabled={retrying || dash.refreshing} onClick={retry}>
            {t('settings.refreshBillingStatus')}
          </button>
        )}
      </div>
    </section>
  );
}
